<template>
  <div class="production_wrap">
    <PCNavbar selectIndex="7"/>
    <MobileNavBar :currentActive="7" />
    <div class="production_img">
      <div class="img_tit">联系我们</div>
      <div class="img_desc">Contact Us</div>
    </div>
	<div class="four_wrap">
	  <el-row type="flex" justify="center" class="out_card" :gutter="10">
	    <el-col
	      :span="7"
	      v-for="(item, index) in contactMsg"
	      :key="index"
	      class="card_item"
	    >
	      <el-card :body-style="{ padding: '0px' }" class="card_content">
	        <div style="padding: 14px">
	          <img :src="item.icon" class="image" />
	          <div style="margin-top: 20px; font-size: 1rem; font-weight: bold">
	            {{ item.tit }}
	          </div>
	          <div class="bottom clearfix">
	            <el-button type="text" class="button" style="font-size:0.7rem;">{{
	              item.desc
	            }}</el-button>
	          </div>
	        </div>
	      </el-card>
	    </el-col>
	  </el-row>
	</div>
	<div class="enter_title_wrap">
		<div class="enter_inner">
		<div class="inner_left">
			<img src="../assets/img/tupianright.png" alt="" />
		</div>
		<div class="inner_center">
			<div class="enter_title">办公地址</div>
			<div class="enter_desc">福建省福安市王基岭工业区665号</div>
		</div>
		<div class="inner_right">
			<img src="../assets/img/tupianleft.png" alt="" />
		</div>
		</div>
	</div>
	<div class="address_map">
		<img src="../assets/img/contact/map.jpg" style="width: 100%;" alt="">
	</div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import ProCard from '@/components/production/ProCard.vue'
import ProCard2 from '@/components/production/ProCard2.vue'
import AdvantageCard from '@/components/production/AdvantageCard.vue'
import imageScroll from '@/components/production/imageScroll.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  data() {
    return {
      contactMsg: [
        {
          tit: '市场合作',
          desc: '',
          icon: require('../assets/img/61.png'),
        },
        {
          tit: '售前咨询',
          desc: '000-000-0000',
          icon: require('../assets/img/60.png'),
        },
        {
          tit: '售后咨询',
          desc: 'Product@yw.com',
          icon: require('../assets/img/61.png'),
        },
      ],
    }
  },
  mounted() {
	this.getContactMsg()
  },
methods: {
  async getContactMsg() {
    try {
      const res = await this.axios.post(
        'http://localhost:8090/manager/ywContactUs/list?page=0&size=10',
		  { title: null, phone: null }, // ✅ 补上你要求的请求体，固定传这个对象，匹配后端@RequestBody
		      { // ✅ 必加请求头，POST传JSON必须加，后端才能正确解析请求体
		        headers: {
		          'Content-Type': 'application/json;charset=UTF-8'
		        }
		      }
        // { params: { page: '0', size: '10' } } // 分页参数保留
      )
      // ========== 核心修改处 ==========
      // 写法1：推荐【可选链+空值合并】，一行搞定，安全到极致，不会报错
	  // console.log(res.content)
      const contactData = res.data.content?.[0] || null;
	// console.log(contactData)
      if (contactData) {
        this.contactMsg[0].desc = contactData.email;
        this.contactMsg[1].desc = contactData.phone;
        // 如需其他字段，正常取值即可，比如
        // this.contactMsg[2].desc = contactData.address;
        // this.contactMsg[3].desc = contactData.officialAccount;
      }
    } catch (error) {
      console.error('联系信息请求失败：', error);
      this.$message?.error('获取联系信息失败，请稍后重试');
    }
  },
},
  components: {
    PCNavbar,
    MobileNavBar,
    ProCard,
    ProCard2,
    AdvantageCard,
    imageScroll,
    CallMe,
    MobileCallme,
  },
}
</script>

<style lang="scss" scoped>
.production_wrap {
  width: 100%;
  .production_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url('../assets/img/contact_bg.png') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
  .four_wrap {
    width: 70%;
    margin: 0 auto;
    background: url('../assets/img/58.e28b1c0.png') 0 0 no-repeat;
    background-size: cover;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 768px) {
      width: 100%;
      height: 150px;
	  margin-top: 25px;
    }
    .out_card {
      width: 100%;
      flex-wrap: wrap;
      .card_item {
        &:nth-child(n + 4) {
          margin-top: 10px;
        }
        .card_content {
          display: flex;
          flex-direction: column;
          text-align: center;
          width: 100%;
          img {
            padding-top: 30px;
            width: 30%;
            @media screen and (max-width: 768px) {
              width: 50%;
            }
          }
        }
      }
    }
  }
  .enter_title_wrap {
    width: 100%;
    margin-top: 100px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
    .enter_inner {
      display: flex;
      justify-content: center;
      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }
        img {
          width: 30%;
        }
      }
      .inner_center {
        width: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;
        @media screen and (max-width: 768px) {
          flex: 2.2;
        }
        .enter_title {
          font-size: 40px;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }
        .enter_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;
          @media screen and (max-width: 768px) {
            margin-top: 10px;
			font-size: 12px;
          }
        }
      }
      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }
        img {
          width: 30%;
        }
      }
    }
  }
  .address_map {
	width: 70%;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	img {
		margin: 50px 0 0 0;
	}
  }
}
</style>